import denormalizeCsvCell from './denormalizeCsvCell';

export default function normalizeMappingName(name) {
  return denormalizeCsvCell(String(name ?? '')).trim().toLowerCase();
}
